<template>
  <div id="page-container"></div>
</template>

<script>
import { useCommonStore } from "@/stores/CommonStore.ts";
import { mapActions } from "pinia";
import { isValidAccessionId } from "@/utils/accessionId.js";
export default {
  name: "QuestionnairePage",
  props: {
    sample_id: String,
    accession_id: String,
    jwtToken: String,
    role: String,
  },
  mounted() {
    this.setSampleId(this.sample_id);
    this.setAccessionId(this.accession_id);
    this.setJwtToken(this.jwtToken);
    this.setRole(this.role);
    // VP-18267: a link carrying accession_id=undefined must not become /hormoneQuestionnaire/undefined. Without
    // a usable accession the view sends the patient to verification with the accession input shown.
    this.$router.push(isValidAccessionId(this.accession_id) ? `/hormoneQuestionnaire/${this.accession_id}` : "/hormoneQuestionnaire");
  },
  methods: {
    ...mapActions(()=>useCommonStore(), ["setSampleId", "setAccessionId", "setJwtToken", "setRole"]),
  },
};
</script>
